export default __webpack_public_path__ + "static/media/PaymentSuccess.4c2d6c9d.svg";